import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { VolumetricItem } from './VolumetricItem';

export const VolumetricMeasurableItem = iotsUtils.makePartialRecordDecoder(
	constants.job.volumetrics.measurableIds,
	VolumetricItem
);
